import { UrlHandlingStrategy, UrlTree } from '@angular/router';

export class CustomUrlHandlingStrategy implements UrlHandlingStrategy {


    shouldProcessUrl(url: UrlTree): boolean {
        return false;
    }

    extract(url: UrlTree): UrlTree {
        return url;
    }

    merge(url: UrlTree, whole: UrlTree): UrlTree{
        return url;
    }
}